// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","rotation":"spinner_rotation__mAn0T"};